export enum LayerType {
  PUBLIC = 'public',
  ASSET = 'asset'
}